import React, { Component } from 'react';
import { LegalCopyright } from 'cx-ui-components';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import messages from './messages';

const styles = {
    legalPolicyDiv: {
        bottom: 0,
        padding: '1.5em'
    }
}

export class LegalPolicy extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div style={styles.legalPolicyDiv}>
        <LegalCopyright
          messages={{
            copyright: this.props.intl.formatMessage(
              messages.copyright,
              {
                currentYear: new Date().getFullYear(),
              }
            ),
            legal: this.props.intl.formatMessage(messages.legal),
            legalLabel: this.props.intl.formatMessage(messages.legalLinkLabel),
          }}
        />
      </div>
    )
  }   
};

LegalPolicy.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(LegalPolicy);